import React, { Component } from 'react';
import { Document, Page } from 'react-pdf';
import Config from '../../config.js'
import Urls from '../../common/Urls';
import Styles from "../../styles/Styles";

export default class PdfViewer extends Component {
    state = {
        membership: 0,
        numPages: null,
        currentFilePageNumber: 1,
        currentFileIndex: 0,

        arrFiles: null,
        intFilesLoaded: 0,
        arrPagesRead : [],

        lightList : false

    }

    constructor(props){
        super(props);
        this.state.membership = props.membership;
        this.state.arrFiles = Config.program.files;
    }

    onDocumentLoadSuccess = (index, numPages) => {
        let arrPagesRead = this.state.arrPagesRead;
        if (typeof arrPagesRead[index] === "undefined") {
            arrPagesRead[index] = [];
            for (let i = 0; i < numPages; i++) {
                arrPagesRead[index][i] = false;
            }
            this.setState({arrPagesRead: arrPagesRead, intFilesLoaded: this.state.intFilesLoaded + 1});
        }
    }

    onDocumentLoadError = ({ error }) => {
        console.log(error);
    }

    getCurrentDocumentUrl(){
        return this.getDocumentUrl(this.state.currentFileIndex);
    }

    getCurrentDocumentName(){
        return this.getDocumentName(this.state.currentFileIndex);
    }

    getCurrentDocumentPageCount(){
        return this.getDocumentPageCount(this.state.currentFileIndex);
    }

    getDocumentName(index){
        let arrPieces = this.state.arrFiles[index].split(".");
        arrPieces.splice(arrPieces.length-1,1);
        return arrPieces.join(".");
    }

    getDocumentUrl(index){
        return Urls.getDocumentPath()+"/"+this.state.membership+"/"+this.state.arrFiles[index];
    }

    getDocumentPageCount(index){
        return this.state.arrPagesRead[index]?this.state.arrPagesRead[index].length:0;
    }

    markCurrentPageAsReadAnGoNext(){
        this.state.arrPagesRead[this.state.currentFileIndex][this.state.currentFilePageNumber-1] = true;
        if (this.state.currentFilePageNumber < this.getCurrentDocumentPageCount()) {
            this.setState({currentFilePageNumber: this.state.currentFilePageNumber + 1});
        }
        else{
            if (this.state.currentFileIndex < this.state.arrFiles.length - 1) {
                this.changeFile(this.state.currentFileIndex + 1)
            }
        }
    }

    validateCurrentFile(){
        for (let i =0;i< this.getCurrentDocumentPageCount(); i++){
            this.state.arrPagesRead[this.state.currentFileIndex][i] = true;
        }
        if (this.state.currentFileIndex < this.state.arrFiles.length -1 ) {
            this.changeFile(this.state.currentFileIndex + 1);
        }
    }



    goPrevious(){
        if (this.state.currentFilePageNumber > 1) {
            this.setState({currentFilePageNumber: this.state.currentFilePageNumber - 1});
        }
        else{
            if (this.state.currentFileIndex != 0) {
                this.changeFile(this.state.currentFileIndex - 1, this.getDocumentPageCount(this.state.currentFileIndex - 1))
            }
        }
    }

    goPreviousDocument(){
        if (this.state.currentFileIndex > 0 ) {
            this.changeFile(this.state.currentFileIndex - 1, 1);
        }
    }

    goNextDocument(){
        if (this.state.currentFileIndex < this.state.arrFiles.length -1 ) {
            this.changeFile(this.state.currentFileIndex + 1,1);
        }
    }

    onPrev = () =>
        this.goPrevious()
    onNext = () => {
        this.markCurrentPageAsReadAnGoNext()
    }
    onValidateDocument = () =>
        this.validateCurrentFile()
    onPrevDocument = () =>
        this.goPreviousDocument()
    onNextDocument = () => {
        this.goNextDocument()
    }



    onFileClick(e, index){
        e.preventDefault();
        this.changeFile(index);
    }

    onArrowListClick(e){
        e.preventDefault();
        this.setState({lightList: !this.state.lightList});
    }


    changeFile(index, numPage=1){
        this.setState({currentFilePageNumber: numPage, currentFileIndex: index });
    }

    allValidate(){
        for(let i =0;i<this.state.arrPagesRead.length;i++){
            if (typeof(this.state.arrPagesRead[i]) !== "undefined") {
                for (let j = 0; j < this.state.arrPagesRead[i].length; j++) {
                    if (this.state.arrPagesRead[i][j] == false) {
                        return false;
                    }
                }
            }
        }
        return true;
    }



    renderFileList(){
        let ctx = this;

        let liFiles = this.state.arrFiles.map(function(name, i){
            let totalPages = 0;
            let totalRead = 0;
            if (typeof ctx.state.arrPagesRead[i] !== "undefined"){
                totalPages = ctx.getDocumentPageCount(i);
                totalRead = ctx.state.arrPagesRead[i].filter(function(x){return x==true}).length;
            }
            let badge = "";
            let displayName= i+1;
            if (!ctx.state.lightList) {
                badge = <span className="badge badge-primary badge-pill">{totalRead}/{totalPages}</span>;
                displayName = ctx.getDocumentName(i);
            }

            if (i === ctx.state.currentFileIndex){
                return <a key={i} href="#" className='d-flex justify-content-between list-group-item list-group-item-primary' ><span>{displayName}</span>{badge}</a>;
            }
            else if (totalPages == totalRead){
                return <a key={i} onClick={(e)=>ctx.onFileClick(e,i)} href="#" className="d-flex justify-content-between list-group-item list-group-item-success" ><span>{displayName}</span>{badge}</a>;
            }
            else if (i < ctx.state.currentFileIndex){
                return <a key={i} onClick={(e)=>ctx.onFileClick(e,i)} href="#" className="d-flex justify-content-between list-group-item list-group-item-warning" ><span>{displayName}</span>{badge}</a>;
            }
            else{
                return <a key={i} onClick={(e)=>ctx.onFileClick(e,i)} href="#" className="d-flex justify-content-between list-group-item" ><span>{displayName}</span>{badge}</a>;
            }
        })

        let arrowStyle = "la-chevron-right";
        let listClass = "files-list";
        if (this.state.lightList){
            listClass = "files-list-light";
            arrowStyle = "la-chevron-left";
        }

        return (

            <div className={"list-group margin-left-s margin-top-l "+listClass}>
                <a onClick={(e)=>this.onArrowListClick(e)} href="#" className={"list-group-item list-group-arrow"}><i className={"la "+arrowStyle}></i></a>
                {liFiles}
            </div>
        );
    }

    renderAllDocuments(){
        let ctx = this;
        let allFiles = this.state.arrFiles.map(function(name, i){
                return <Document key={i}
                    file={ctx.getDocumentUrl(i)}
                    onLoadSuccess={({numPages}) => ctx.onDocumentLoadSuccess(i, numPages)}
                >
                </Document>;
        })
        return (
                <div className={"d-none"}>{allFiles}</div>

        );
    }

    renderNav(boolWithPages= true, boolWithDoc = false, boolValidation = false){
        return (
            <div>
                {boolWithPages?<ul className="pager">
                    {this.state.currentFilePageNumber !=1?<li className="previous"><a onClick={this.onPrev} href="#">Page précédente</a></li>:""}
                    <li>Page {this.state.currentFilePageNumber} / {this.getCurrentDocumentPageCount()}</li>
                    {this.state.currentFilePageNumber !=this.getCurrentDocumentPageCount()?<li className="next"><a onClick={this.onNext} href="#">Page suivante</a></li>:""}
                </ul>:""}
                {boolWithDoc?
                    <ul className="pager">
                    {this.state.currentFileIndex !=0?<li className="previous"><a onClick={this.onPrevDocument} href="#">Document précédent</a></li>:""}
                    <li className="next"><a onClick={this.onNextDocument} href="#">Document suivant</a></li>
                </ul>:""}
            </div>


        )
    }

    renderValidationButton(){
        if (this.state.currentFilePageNumber == this.getCurrentDocumentPageCount()) {
            return (
                <div>
                    <ul className="pager">
                        <li><a onClick={this.onValidateDocument} href="#">Valider le document</a></li>
                    </ul>
                </div>
            )
        }
        else{
            return("");
        }
    }

    renderFinishButton(){
        return (<div className="text-center margin-top-l">
            <button style={Styles.Style.bgColorSecondary} className="btn btn-lg btn-primary-primary" onClick={()=>this.props.onFinish()}>Je valide l'ensemble des documents</button>
        </div>)
    }



    render() {
        const { currentFilePageNumber, numPages } = this.state;

        return (
            <div>
                {this.renderFileList()}
                {this.allValidate()? this.renderFinishButton():""}
                <div className={"row"}>
                    <div style={{ width: 750 }} className="margin-left-s">
                        {this.renderNav(false,true)}
                        <h2 style={Styles.Style.bgColorSecondary} className="clearfix text-center margin-bottom-xs margin-top-s file-title">{this.getCurrentDocumentName()}</h2>
                        {this.renderNav(true)}
                        <Document
                            file={this.getCurrentDocumentUrl()}
                            onLoadSuccess={({numPages}) => this.onDocumentLoadSuccess(this.state.currentFileIndex, numPages)}
                            onLoadError={this.onDocumentLoadError}
                            renderMode={"svg"}
                        >
                            <Page pageNumber={currentFilePageNumber} width={750}  />
                        </Document>
                        {this.renderNav(true, false)}
                        {this.renderValidationButton()}
                    </div>
                    {this.state.arrFiles.length >= this.state.intFilesLoaded? this.renderAllDocuments() :""}
                </div>
                {this.allValidate()? this.renderFinishButton():""}


            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pdf/PdfViewer.js